// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_POST_CREATE_OPTIONS = "Mo\u017enosti";
export const SEND = "Odo\u0161li";
export const SEO_TITLE_FORUM_THREAD_NEW = "Pridaj diskusiu";
